import { NoteMessage } from '@/@types/messages/NoteMessage'
import { AppConfig } from '@/app.config'
import authenticatedFetch from '@/authenticatedFetch'
import { MiscellaneousService } from './miscellaneous.service'
import { ObjectCreatedResponse } from '@/@types/responses/common/ObjectCreatedResponse'
import { UpdateQuoteServiceMessage } from '@/@types/messages/UpdateQuoteServiceMessage'
import { UpdateQuoteServicesMessage } from '@/@types/messages/UpdateQuoteServicesMessage'

export class QuoteServiceService {
  private appConfig: AppConfig
  private miscellaneousService: MiscellaneousService

  constructor(miscellaneousService: MiscellaneousService) {
    this.appConfig = new AppConfig()
    this.miscellaneousService = miscellaneousService
  }

  public createQuoteServiceNote(quoteServiceId: number, noteMessage: NoteMessage): Promise<ObjectCreatedResponse<number>> {
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(noteMessage)
    }

    return authenticatedFetch(`${this.appConfig.sacServicesUrl}/v1/quote-services/${quoteServiceId}/notes`, this.miscellaneousService, requestOptions).then(async response => {
      const json = await response.json()
      return new ObjectCreatedResponse<number>(json.id)
    })
  }

  public deleteQuoteService(id: number): Promise<void> {
    const requestOptions = {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' }
    }

    return authenticatedFetch(`${this.appConfig.sacServicesUrl}/v1/quote-services/${id}`, this.miscellaneousService, requestOptions).then(() => {
      return Promise.resolve()
    })
  }

  public updateQuoteService(quoteServiceId: number, updateQuoteServiceMessage: UpdateQuoteServiceMessage): Promise<void> {
    const requestOptions = {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(updateQuoteServiceMessage)
    }

    return authenticatedFetch(`${this.appConfig.sacServicesUrl}/v1/quote-services/${quoteServiceId}`, this.miscellaneousService, requestOptions).then(() => {
      return Promise.resolve()
    })
  }

  public updateQuoteServices(updateQuoteServicesMessage: UpdateQuoteServicesMessage): Promise<void> {
    const requestOptions = {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(updateQuoteServicesMessage)
    }

    return authenticatedFetch(`${this.appConfig.sacServicesUrl}/v1/quote-services`, this.miscellaneousService, requestOptions).then(() => {
      return Promise.resolve()
    })
  }
}